/**
 *  生成随机字符串
 * @param {Number} len 生成字符串长度
 */
export function randomString(len) {
    const defaultStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const defaultStrLen = defaultStr.length;
    let str = '';
    for (let i = 0; i < len; i++) {
        str += defaultStr.charAt(Math.floor(Math.random() * defaultStrLen));
    }
    return str;
}
